<template>
    <div>
        <el-card class="box-card" style="width: 26rem; height: 100%" v-drag>
            <div slot="header">
                <span style="font-weight: 600">{{
                    clickDataPopInfo.name
                }}</span>
                <i class="el-icon-close" style="float: right; margin-right: 10px; cursor: pointer"
                    @click="closeClickPop"></i>
            </div>
            <div style="text-align: left">
                <el-row style="margin-top: 0.6rem">
                    <el-col :span="6" style="text-align: right">
                        <strong>所属厅县：</strong>
                    </el-col>
                    <el-col :span="6">
                        <span>{{
                            clickDataPopInfo.lev2_name == null
                            ? '暂无介绍'
                            : clickDataPopInfo.lev2_name
                        }}</span>
                    </el-col>
                    <el-col :span="4" style="text-align: right">
                        <strong>方位：</strong>
                    </el-col>
                    <el-col :span="8">
                        <span>{{
                            clickDataPopInfo.location == null
                            ? '暂无介绍'
                            : clickDataPopInfo.location
                        }}</span>
                    </el-col>
                </el-row>

                <el-row style="margin-top: 0.6rem">
                    <el-col :span="6" style="text-align: right">
                        <strong>距城里数：</strong>
                    </el-col>
                    <el-col :span="14">
                        <span style="line-height: 22px">{{
                            clickDataPopInfo.distance == null
                            ? '暂无介绍'
                            : clickDataPopInfo.distance
                        }}</span>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 0.6rem">
                    <el-col :span="6" style="text-align: right">
                        <strong>户数：</strong>
                    </el-col>
                    <el-col :span="6">
                        <span style="line-height: 22px">{{
                            clickDataPopInfo.household == 0
                            ? '无'
                            : clickDataPopInfo.household
                        }}</span>
                    </el-col>
                    <el-col :span="4" style="text-align: right">
                        <strong>口数：</strong>
                    </el-col>
                    <el-col :span="8">
                        <span style="line-height: 22px">{{
                            clickDataPopInfo.population == 0
                            ? '无'
                            : clickDataPopInfo.population
                        }}</span>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 0.6rem">
                    <el-col :span="6" style="text-align: right">
                        <strong>附录：</strong>
                    </el-col>
                    <el-col :span="14">
                        <span>{{ clickDataPopInfo.excursus }}</span>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 0.6rem">
                    <el-col :span="6" style="text-align: right">
                        <strong>承办绅董：</strong>
                    </el-col>
                    <el-col :span="14">
                        <span>{{ clickDataPopInfo.censusenum }}</span>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 0.6rem">
                    <el-col :span="6" style="text-align: right">
                        <strong>今地名：</strong>
                    </el-col>
                    <el-col :span="14">
                        <span>{{ clickDataPopInfo.n_position }}</span>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 0.6rem">
                    <el-col :span="6" style="text-align: right">
                        <strong>定位依据：</strong>
                    </el-col>
                    <el-col :span="14">
                        <span>{{ clickDataPopInfo.input_reas }}</span>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 0.6rem">
                    <el-col :span="6" style="text-align: right">
                        <strong> 最后定位：</strong>
                    </el-col>
                    <el-col :span="14">
                        <strong>由{{
                            '“' + clickDataPopInfo.input_work + '”'
                        }}</strong>
                        {{ '的' }}

                        <strong>{{
                            clickDataPopInfo.other == null
                            ? '“' + '张三' + '”'
                            : '“' + clickDataPopInfo.other + '”'
                        }}</strong>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 0.6rem">
                    <el-col :span="6" style="text-align: right">
                        <span> &nbsp;&nbsp;&nbsp;&nbsp;</span>
                    </el-col>
                    <el-col :span="14">
                        <strong>于{{
                            '“' + clickDataPopInfo.input_time + '”'
                        }}</strong>
                        <span>完成。</span>
                    </el-col>
                </el-row>

                <el-row style="margin-top: 0.6rem; text-align: right">
                    <el-col :span="12">
                        <el-button type="primary" @click="correctLocation">纠正定位</el-button>
                    </el-col>
                    <el-col v-if="isAdmin()" :span="8">
                        <el-button type="danger" @click="deleteLocation">删除定位</el-button>
                    </el-col>
                </el-row>
                <!-- <el-row style="text-align: right">
                 
                </el-row> -->
                <el-row style="
                        margin-top: 0.6rem;
                        text-align: left;
                        margin-left: 1.6rem;
                    ">
                    <el-col>
                        <strong>历史定位表：</strong>
                    </el-col>
                </el-row>

                <el-row style="
                        margin-top: 0.6rem;
                        margin-left: 1.6rem;
                        margin-right: 1.6rem;
                        margin-bottom: 0.6rem;
                    ">
                    <el-table style="width: 100%" :data="locationPassTable" max-height="150px" :header-cell-style="{
                        background: '#eef1f6',
                        color: '#606266',
                    }">
                        <el-table-column label="定位人员" prop="tName" width="80">
                        </el-table-column>
                        <el-table-column label="定位操作" prop="content" width="80">
                        </el-table-column>
                        <!-- <el-table-column
                            label="地名"
                            prop="n_position"
                            show-overflow-tooltip=""
                        >
                        </el-table-column> -->
                        <el-table-column label="定位时间" prop="date" show-overflow-tooltip="">
                        </el-table-column>
                    </el-table>
                </el-row>
            </div>
        </el-card>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            locationPassTable: [],
        }
    },
    watch: {
        clickDataPopInfo(newValue) {
            this.getLocationPassTable()
        },
    },
    props: {
        clickDataPopInfo: Object,
    },
    mounted() {
    },
    computed: {},
    methods: {
        getUser() {
            if (this.$cookie.get('mail') == null) {
                return this.$store.state.V3mail
            } else {
                return this.$cookie.get('mail')
            }
        },
        // 判断是否登录
        isLoginSuccess() {
            if (
                this.$cookie.get('isLogin') == 'success' ||
                this.$store.state.V3loginState == true
            ) {
                return true
            } else {
                return false
            }
        },
        isAdmin() {
            if (
                this.$cookie.get('V3loginRole') == '管理员' ||
                this.$store.state.V3loginRole == '管理员'
            ) {
                return true
            } else {
                return false
            }
        },
        getLocationPassTable() {
            let dataID = this.clickDataPopInfo.id + ''
            axios({
                url: $webConfig.V3.backendAPI + 'getPassDatas',
                method: 'post',
                data: JSON.stringify({
                    dataID: dataID,
                }),
            }).then((res) => {
                this.locationPassTable = res.data.data.resList
            })
        },

        closeClickPop() {
            this.$emit('closeClickPop')
        },
        // 开始纠正定位
        correctLocation() {
            if (this.isLoginSuccess()) {
                this.$emit('correctLocation', this.clickDataPopInfo)
            } else {
                this.$message({
                    message: '游客模式，无法纠正定位，请先登录。',
                    type: 'error',
                })
            }
        },
        deleteLocation() {
            if (this.isLoginSuccess() && this.isAdmin()) {
                this.$emit('deleteLocation', this.clickDataPopInfo)
            } else {
                this.$message({
                    message: '非管理员，无法删除定位',
                    type: 'error',
                })
            }
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/V3/Main/Home/comClickDataPop.vue